import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom'; // Import useParams hook
import customCSS from './Allusers.module.css';
import ENV from '../../constants/env-constants';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { formatNumbers } from '../../utils/formatNumbers';

function UserTransactions() {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Set rows per page
  const { userid } = useParams(); // Extract userid from route parameters
  const location = useLocation()

  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin User-Transactions Page' });
  }, []);
  // Fetch user's transactions from backend API
  useEffect(() => {
    const fetchTransactions = async () => {
      const response = await fetch(`${ENV.API_URL}/api/transactions/${userid}`, {
        method: 'GET', // Ensure method is POST as per your API specification
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      setTransactions(data);
    };

    fetchTransactions().catch(console.error);
  }, [userid]); // Dependency array includes userid to refetch if it changes

  // Calculate the current rows to display
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = transactions.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(transactions.length / rowsPerPage); i++) {
    pageNumbers.push(i);
  }

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <Helmet>
          <meta charSet="utf-8" />
          <title>User-Transactions</title>
        </Helmet>
        <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>User Transactions</h1>

          <div className={customCSS.layoutWrapper}>
            <div className={customCSS.layoutContainer}>
              <div className={customCSS.tableWrapper}>
                <table className={customCSS.table}>
                  <thead>
                    <tr>
                      <th className={customCSS.th}>Transaction ID</th>
                      <th className={customCSS.th}>Amount</th>
                      <th className={customCSS.th}>Frequency</th>
                      <th className={customCSS.th}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* filter is added to remove transactions with 0 dollars. */}
                    {/* Why 0 dollars transaction exists? Ans: These are generally added in transactions to add free trees recievers, even though they haven't spend money but the tree is planted on their behalf so it will be like 1 tree for 0 dollars */}
                    {currentRows.filter((transaction) => Boolean(transaction.amount)).map((transaction) => (
                      <tr key={transaction.tid}>
                        <td className={customCSS.td}>{transaction.tid}</td>
                        <td className={customCSS.td}>{((transaction.amount ? '$' : '') + formatNumbers(transaction.amount)) || 'NA'}</td>
                        <td className={customCSS.td}>{transaction.frequency || 'NA'}</td>
                        <td className={customCSS.td}>{formatDate(transaction.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={customCSS.pagination}>
                {pageNumbers.map(number => (
                  <button key={number} onClick={() => paginate(number)} className={customCSS.pageLink}>
                    {number}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserTransactions;
